module.exports = __webpack_public_path__ + "static/img/hospital_registrations.294e8ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hospital_registrations.jpg
// module id = +zOA
// module chunks = 7